var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"q10__jumbotron"},[_c('image-with-descriptions',{staticClass:"mb-8 mt-0",attrs:{"options":{
                image:
                    'pages/' +
                    _vm.currentPage.slug +
                    '/' +
                    _vm.currentPage.images.oImage1.src,
                descriptions: [
                    {
                        text: _vm.currentPage.images.oImage1.edf,
                        position: 'bottom-right', // top/bottom-left/right
                        orientation: 'horizontal', // vertical, horizontal
                    } ],
            }}})],1),_c('div',{staticClass:"page"},[_c('div',{staticClass:"container px-11 2xl:px-3 mb-14 m-auto"},[_c('title-s-chapter',{attrs:{"options":{
                    from: 'selective_green',
                    to: 'to-golden_sand',
                }}},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleTitle.title)}})]),_c('p',{staticClass:"font-bold text-tundora text-xl mb-5",domProps:{"innerHTML":_vm._s(_vm.currentPage.content.sArticleDescription.text)}}),_c('div',{staticClass:"container-components lg:mb-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative mt-8"},[_c('hotspot-richmedia',{staticClass:"-top-10 right-2 md:-top-12 md:-right-3 lg:right-2 lg:-top-6 ",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    "Gilboa, de l’hydro dans le mix israélien"
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphOne_Title.text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphOne_Content.text
                        )}})],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTwo_Title.text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphTwo_Content.text
                        )}}),_c('div',[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        "Remplacement des conduites forcées de Sabart (2017-2019)"
                                    ),
                                }}})],1),_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage2.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage2
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphThree_Title
                                    .text
                            )}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphThree_Content.text
                        )}}),_c('div',[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage3.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage3
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative"},[_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage4.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage4
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage4
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('div',{staticClass:"relative mt-12"},[_c('hotspot-richmedia',{staticClass:"-top-10 md:-top-10 lg:-top-11 right-5 md:-right-2 lg:right-8 xl:-top-11 xl:right-3",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'PKWeir, l’innovation virtuose'
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'top',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFour_Title
                                    .text
                            )}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphFour_Content.text
                        )}}),_c('image-with-descriptions',{attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage5.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage5.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: _vm.currentPage.images.oImage5.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1)]),_c('image-with-descriptions',{staticClass:"mb-4 lg:mb-8 q10_image-redimensioned",attrs:{"options":{
                    image:
                        'pages/' +
                        _vm.currentPage.slug +
                        '/' +
                        _vm.currentPage.images.oImage6.src,
                    descriptions: [
                        {
                            text: _vm.currentPage.images.oImage6.alt,
                            position: 'bottom-right', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        },
                        {
                            text: _vm.currentPage.images.oImage6.text,
                            position: 'top-left', // top/bottom-left/right
                            orientation: 'horizontal', // vertical, horizontal
                        } ],
                }}}),_c('div',{staticClass:"container-components mb-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"relative mt-8"},[_c('hotspot-richmedia',{staticClass:"-top-10 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Débit réservé : la calebasse, une innovation brevetée'
                                ),
                            }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphFive_Title
                                    .text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphFive_Content.text
                        )}}),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Débit réservé : le vivant avant tout'
                                ),
                            }}}),_c('image-with-descriptions',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage7.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage7
                                            .alt,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    },
                                    {
                                        text: _vm.currentPage.images.oImage7
                                            .text,
                                        position: 'top-left', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSix_Title.text
                            )}})],1),_c('p',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphSix_Content.text
                        )}}),_c('image-with-descriptions',{staticClass:"mb-8",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage8.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage8.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphSeven_Title
                                    .text
                            )}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphSeven_Content.text
                        )}}),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                icon: 'diaporama',
                                collection: _vm.getRichmediaByCollection(
                                    _vm.currentPage,
                                    'Barrage du Chambon - Travaux de confortement (2014)'
                                ),
                            }}}),_c('image-with-descriptions',{staticClass:"mb-8",attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage9.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage9
                                            .edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1)],1),_c('div',{staticClass:"card"},[_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphEight_Content.text
                        )}}),_c('Triangles',{attrs:{"options":{
                            colors: ['#81C341', '#B7DD92', '#cce5a4'],
                            direction: 'bottom',
                        }}}),_c('image-with-descriptions',{staticClass:"mb-8",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage10.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage10.alt,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                },
                                {
                                    text: _vm.currentPage.images.oImage10.text,
                                    position: 'top-left', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}})],1),_c('div',{staticClass:"card ",staticStyle:{"padding-top":"0"}},[_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-9 right-2",attrs:{"options":{
                            icon: 'diaporama',
                            collection: _vm.getRichmediaByCollection(
                                _vm.currentPage,
                                'Remplacement des robinets sphériques de Lardit'
                            ),
                        }}})],1),_c('TitleParagraph',{attrs:{"options":{
                            from: 'from-selective_green',
                            to: 'to-golden_sand',
                        }}},[_c('Triangles',{attrs:{"options":{
                                colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                direction: 'bottom',
                            }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphNine_Title
                                    .text
                            )}})],1),_c('image-with-descriptions',{staticClass:"eliminate-margin",attrs:{"options":{
                            image:
                                'pages/' +
                                _vm.currentPage.slug +
                                '/' +
                                _vm.currentPage.images.oImage11.src,
                            descriptions: [
                                {
                                    text: _vm.currentPage.images.oImage11.edf,
                                    position: 'bottom-right', // top/bottom-left/right
                                    orientation: 'horizontal', // vertical, horizontal
                                } ],
                        }}}),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                            _vm.currentPage.content.sParagraphNine_Content.text
                        )}}),_c('div',{staticClass:"card relative top-7"}),_c('TitleParagraph',{attrs:{"options":{
                                from: 'from-selective_green',
                                to: 'to-golden_sand',
                            }}},[_c('Triangles',{attrs:{"options":{
                                    colors: ['#81C341', '#B7DD92', '#cce5a4'],
                                    direction: 'bottom',
                                }}}),_c('span',{domProps:{"innerHTML":_vm._s(
                                    _vm.currentPage.content.sParagraphTen_Title.text
                                )}})],1),_c('span',{staticClass:"text-nandor 2xl:text-lg",domProps:{"innerHTML":_vm._s(
                                _vm.currentPage.content.sParagraphTen_Content.text
                            )}}),_c('div',{staticClass:"relative"},[_c('hotspot-richmedia',{staticClass:"top-2 right-2",attrs:{"options":{
                                    icon: 'diaporama',
                                    collection: _vm.getRichmediaByCollection(
                                        _vm.currentPage,
                                        'Tolla : opération de colmatage en eaux profondes'
                                    ),
                                }}})],1),_c('image-with-descriptions',{staticStyle:{"margin":"0"},attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage12.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage12.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                            }}})],1),_c('div',{staticClass:"card"},[_c('article-note',{attrs:{"options":{
                                image:
                                    'pages/' +
                                    _vm.currentPage.slug +
                                    '/' +
                                    _vm.currentPage.images.oImage13.src,
                                descriptions: [
                                    {
                                        text: _vm.currentPage.images.oImage13.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                    } ],
                                verticalcontent:
                                    _vm.currentPage.content.sParagraphEleven_Title
                                        .text,
                                content:
                                    _vm.currentPage.content.sParagraphEleven_Content
                                        .text,
                                color: {
                                    verticalcontent: 'text-cornflower_blue',
                                    content: 'text-nandor',
                                },
                                fontSize: {
                                    verticalcontent: 'text-4xl xl:text-2xl',
                                    content: '',
                                },
                            }}})],1)])])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }